<template>
    <div class="project project-main">
        <Head />
        <div class="project-box1">
            <h3 class="animated fadeIn">{{$t('project.col1.i1')}}</h3>
            <p class="animated bounceInUp delay-1s">{{$t('project.col1.i2')}} </p>
            <div class="icon">
                <span class="name icon-see-name">{{$t('project.col1.i3')}}</span>
                <span class="subitem" v-html="$t('project.col1.i4')"></span>
            </div>
        </div>
        <div class="project-box2 node-anchor" >
            <p class="module1" :class="{'animated fadeInUp': animate1}" ref="animate1">
                {{$t('project.col2.i1')}}
            </p>
            <div class="module2">{{$t('project.col2.i2')}}</div>
            <div class="module3">
                <div class="module-box1">
                    <div class="left">
                        <div class="row">
                            <div class="col-1">
                                <span class="title">{{$t('project.col2.i3')}}</span>
                                <span class="des">{{$t('project.col2.i4')}}</span>
                            </div>
                            <div class="col-2">
                                <span class="title">{{$t('project.col2.i5')}}</span>
                                <span class="des">{{$t('project.col2.i6')}}</span>
                            </div>
                        </div>
                        <div class="row row1">
                            <span class="title">{{$t('project.col2.i7')}}</span>
                            <span class="des">{{$t('project.col2.i8')}}</span>
                            <span class="des">{{$t('project.col2.i9')}}</span>
                        </div>
                    </div>
                    <div class="right">
                        {{$t('project.col2.i10')}}
                    </div>
                </div>
                <div class="module-box2">
                    <div class="row1">
                        <span class="label">{{$t('project.col2.i11')}}</span><span class="small">{{$t('project.col2.i12')}}</span>
                    </div>
                    <div class="row2">
                        <span class="label">{{$t('project.col2.i13')}}</span><span class="small">{{$t('project.col2.i14')}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="tab2" class="project-box3">
            <h3 ref="animate2" :class="{'animated fadeInLeft': animate2}">{{$t('project.col3.i1')}}</h3>
            <p :class="{'animated fadeInLeft delay-1s': animate2}">{{$t('project.col3.i2')}}</p>
            <div class="box-list">
                <ul class="left">
                    <li>
                        <img src="../../assets/overview/overview_build1.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i3')}}</div>
                        <div class="info">{{$t('project.col3.i4')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build3.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i5')}}</div>
                        <div class="info">{{$t('project.col3.i6')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build5.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i7')}}</div>
                        <div class="info">{{$t('project.col3.i8')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build7.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i9')}}</div>
                        <div class="info">{{$t('project.col3.i10')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build9.png" alt="">
                    </li>
                </ul>
                <ul class="right">
                    <li class="desc" style="padding-top: 43px; height: 147px;">
                        <div class="title">{{$t('project.col3.i11')}}</div>
                        <div class="info">{{$t('project.col3.i12')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build2.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i13')}}</div>
                        <div class="info">{{$t('project.col3.i14')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build4.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i15')}}</div>
                        <div class="info">{{$t('project.col3.i16')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build6.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i17')}}</div>
                        <div class="info">{{$t('project.col3.i18')}}</div>
                    </li>
                    <li>
                        <img src="../../assets/overview/overview_build8.png" alt="">
                    </li>
                    <li class="desc">
                        <div class="title">{{$t('project.col3.i19')}}</div>
                        <div class="info">{{$t('project.col3.i20')}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="project-box4">
            <div class="main">
                <div class="box-left">
                    <h3 ref="animate3" :class="{'animated fadeInLeft': animate3}">{{$t('project.col4.i1')}}</h3>
                    <p class="p1" :class="{'animated fadeInLeft delay-1s': animate3}">{{$t('project.col4.i2')}}</p>
                    <p class="p2" :class="{'animated fadeInLeft delay-1s': animate3}">{{$t('project.col4.i3')}}</p>
                    <div class="more ">
                        <router-link to="/data" class="learn-more-hover">
                            <span class="more-img-outer"></span>
                            <span class="more-right-word">{{$t('project.col4.i4')}}</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-right">
                    <ul class="left">
                        <li><img src="../../assets/overview/overview_data_pic1.png" alt=""></li>
                        <li><img src="../../assets/overview/overview_data_pic3.png" alt=""></li>
                    </ul>
                    <ul class="right">
                        <li><img src="../../assets/overview/overview_data_pic2.png" alt=""></li>
                        <li><img src="../../assets/overview/overview_data_pic4.png" alt=""></li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="tab1" class="project-box5">
            <div class="left">
                <img src="../../assets/overview/overview_welms_pic.png" alt="">
            </div>
            <div class="right">
                <h3 ref="animate4" :class="{'animated fadeIn': animate4}">{{$t('project.col5.i1')}}</h3>
                <p class="p1" :class="{'animated fadeIn delay-1s': animate4}">{{$t('project.col5.i2')}}</p>
                <p class="p2" :class="{'animated fadeIn delay-1s': animate4}">{{$t('project.col5.i3')}}</p>
                <div class="more">
                    <router-link to="/welmshome" class="learn-more-hover">
                        <span class="more-img-outer"></span>
                        <span class="more-right-word" style="color: #333">{{$t('project.col5.i4')}}</span>
                     </router-link>
                </div>
            </div>
        </div>
        <div class="project-box6">
            <div class="main">
                <div class="left">
                    <h3 ref="animate5" :class="{'animated fadeInLeft': animate5}">
                        <img class="logo" src="../../assets/overview/overview_demos_logo.png" alt="">
                        <span>{{$t('project.col6.i1')}}</span>
                    </h3>
                    <p class="p1" :class="{'animated fadeInLeft delay-1s': animate5}">{{$t('project.col6.i2')}}</p>
                    <p class="p2" :class="{'animated fadeInLeft delay-1s': animate5}">{{$t('project.col6.i3')}}</p>
                    <div class="more">
                        <a href="https://global.wdyedu.com/" target="_blank" class="learn-more-hover">
                            <span class="more-img-outer"></span>
                            <span class="more-right-word" style="color: #333">{{$t('project.col6.i4')}}</span>
                        </a>
                    </div>
                </div>
                <div class="right">
                    <img src="../../assets/overview/overview_domos_pic.png" alt="">
                </div>
            </div>
        </div>
        <div id="tab3" class="project-box7">
            <div class="main">
                <h3 ref="animate6" :class="{'animated fadeInDown': animate6}">{{$t('project.col7.i1')}}</h3>
                <p :class="{'animated fadeInDown': animate6}">{{$t('project.col7.i2')}}</p>
                <ul>
                    <li :class="{'animated fadeInDown delay-1s': animate6}">{{$t('project.col7.i3')}}</li>
                    <li :class="{'animated fadeInDown delay-1s': animate6}">{{$t('project.col7.i4')}}</li>
                    <li :class="{'animated fadeInDown delay-1s': animate6}">{{$t('project.col7.i5')}}</li>
                </ul>
                <div class="more ">
                    <router-link to="/classrooms" class="learn-more-hover">
                        <span class="more-img-outer"></span>
                        <span class="more-right-word" style="color: #fff">{{$t('project.col7.i6')}}</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="project-box8">
            <div class="main">
                <div class="left">
                    <h3 ref="animate7" :class="{'animated fadeInLeft': animate7}">{{$t('project.col8.i1')}}</h3>
                    <p :class="{'animated fadeInLeft delay-1s': animate7}">{{$t('project.col8.i2')}}</p>
                    <div class="more">
                        <router-link to="/solution" class="learn-more-hover">
                            <span class="more-img-outer"></span>
                            <span class="more-right-word" style="color: #333">{{$t('project.col8.i3')}}</span>
                        </router-link>
                        <!-- <router-link >
                            <img src="../../assets/overview/more.png" alt="" class="more-img">
                            <span></span>
                        </router-link> -->
                    </div>
                </div>
                <div class="right">
                    <img src="../../assets/overview/overview_vr_pic.png" alt="">
                </div>
            </div>
        </div>
        <div class="project-box9">
            <div class="main">
                <div class="left">
                    <img src="../../assets/overview/overview_look_pic.png" alt=""> 
                </div>
                <div class="right">
                    <img class="logo" ref="animate8" :class="{'animated fadeInRight': animate8}" src="../../assets/overview/overview_look_logo.png" alt="">
                    <p :class="{'animated fadeInRight delay-1s': animate8}">{{$t('project.col9.i1')}}</p>
                    <div class="more">
                        <router-link to="/look" class="learn-more-hover">
                            <span class="more-img-outer"></span>
                            <span class="more-right-word" style="color: #fff">{{$t('project.col9.i2')}}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div id="tab4" class="project-box10">
            <div class="main">
                <h3 ref="animate9" :class="{'animated fadeIn': animate9}">{{$t('project.col10.i1')}}</h3>
                <div class="info" :class="{'animated fadeIn delay-1s': animate9}">
                    <div class="left">
                        <h3>{{$t('project.col10.i2')}}</h3>
                        <p><span>3,000+ </span> {{$t('project.col10.i3')}}</p>
                        <p><span>8,000+ </span> {{$t('project.col10.i4')}}</p>
                        <p><span>3,500+ </span> {{$t('project.col10.i5')}} </p>
                        <p><span>21 </span> {{$t('project.col10.i6')}}</p>
                    </div>
                    <div class="right">
                        <h3>{{$t('project.col10.i7')}}</h3>
                        <p>{{$t('project.col10.i8')}}</p>
                        <p>{{$t('project.col10.i9')}}</p>
                        <p>{{$t('project.col10.i10')}}</p>
                        <p>{{$t('project.col10.i11')}}</p>
                    </div>
                </div>
                <h4>{{ tab[tabNum].title }}</h4>
                <p class="desc">{{ tab[tabNum].info }} </p>
                <div style="position: relative">
                     <ul>
                        <li @mouseover="move(0)">
                            <a href="https://www.demos.fr/" target="_blank">
                                <img src="../../assets/overview/overview_partner_logo1.png" alt="">
                            </a>
                        </li>
                        <li @mouseover="move(1)">
                            <a href="https://www.hemsleyfraser.com/" target="_blank">
                                <img src="../../assets/overview/overview_partner_logo2.png" alt="">
                            </a>
                        </li>
                        <li @mouseover="move(2)">
                            <a href="https://www.mindonsite.com/en/" target="_blank">
                                <img src="../../assets/overview/overview_partner_logo3.png" alt="">
                            </a>
                        </li>
                        <!--  :class="[tabNum == 3 ? 'on' : '']" -->
                        <li @mouseover="move(3)">
                            <a href="//www.simultrain.swiss/" target="_blank">
                            <img src="../../assets/overview/overview_partner_logo4.png" alt="">
                            </a>
                        </li>
                    </ul>
                    <span class="on" :style="{left: `${tabNum * 300 + 150}px`}"></span>
                </div>
               
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import scroll from '../mixin/scroll';

export default {
    components: {
        Head,
        Footer
    },
    mixins: [scroll],
    watch: {
        '$route'(newVal,oldVal){
            // eslint-disable-next-line no-console
            console.log(newVal+"---"+oldVal);
        }

    },
    data() {
        return {
            tabNum: 0,
            refArray: [
                {ref: 'animate1', show: 'animate1', offset: 20},
                {ref: 'animate2', show: 'animate2',},
                {ref: 'animate3', show: 'animate3',},
                {ref: 'animate4', show: 'animate4',},
                {ref: 'animate5', show: 'animate5',},
                {ref: 'animate6', show: 'animate6',},
                {ref: 'animate7', show: 'animate7',},
                {ref: 'animate8', show: 'animate8',},
                {ref: 'animate9', show: 'animate9',},
            ],
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            animate6: false,
            animate7: false,
            animate8: false,
            animate9: false,
            tab: [
            ]
        }
    },
    created() {
        this.tab = this.$t('project.tab');
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        move(index) {
            this.tabNum = index;
        }
    },
}
</script>
<style lang="less">
.project-main {
    .project {
        width: 100%;
        overflow: hidden;
        a {
            text-decoration: none;
            color: inherit;
        }
    }
    .project-box1 {
        background-image: url('../../assets/overview/overview_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 700px;
        box-sizing: border-box;
        padding-top: 200px;
        color: #ffffff;
        text-align: center;
        h3 {
            width: 1200px;
            margin: 0 auto;
            font-size: 60px;
        }
        
        p {
            line-height: 30px;
            font-size: 16px;
            width: 822px;
            font-family: HelveticaNeue, Arial;
            margin: 50px auto 0;
        }

        .icon {
            top: 134px;
            margin: 0 auto;
            position: relative;
            width: 200px;
            height: 200px;
            border-radius: 50%;
            background-color: #f59f44;
            &:after {
                position: absolute;
                content: '';
                width: 0;
                height: 0;
                left: 50%;
                transform: translateX(-50%);
                bottom: -9px;
                border-right: 12px transparent solid;
                border-left: 12px transparent solid;
                border-top: 12px #f59f44 solid;
            }
            span {
                padding-top: 32px;
                display: block;
                font-size: 36px;
            }
            span~span {
                text-align: center;
                padding-top: 12px;
                font-size: 16px;
                line-height: 24px;
            }
        }
    }
    .project-box2 {
        height: 1092px;
        background: linear-gradient(360deg, #F7F7F7 0%, #FFFFFF 100%);
        .module1 {
            padding-top: 154px;
            text-align: center;
            line-height: 30px;
            width: 860px;
            color: #666666;
            margin: 0 auto 70px;
        }

        .module2 {
            padding-top: 14px;
            margin: 0 auto;
            text-align: center;
            width: 400px;
            border-top: 2px solid #FD8E0D;
            color: #FD8E0D;
            font-weight: bold;
        }

        .module3 {
            width: 1200px;
            margin: 0 auto;
            margin-top: 60px;
            span {
                display: block;
            }
            .module-box1 {
                height: 342px;
                display: flex;
                .left {
                    width: 820px;
                }
                .right {
                    margin-left: 6px;
                    flex: 1;
                    background: url('../../assets/overview/overview_card_re.png');
                    color: #ffffff;
                    font-size: 30px;
                    box-sizing: border-box;
                    padding: 38px 29px 57px 44px;
                    line-height: 52px;
                }
                .row {
                    display: flex;
                    height: 168px;
                    .col-1 {
                        flex: 1;
                        background: url('../../assets/overview/overview_card_content.png');
                        background-size: cover;
                        padding: 38px 0 0 40px;
                        box-sizing: border-box;
                        .title {
                            color: #ffffff;
                            font-size: 32px;
                        }
                        .des {
                            margin-top: 10px;
                            color: #ffffff;
                            font-size: 16px;
                            font-family: HelveticaNeue, Arial;
                            line-height: 26px;
                        }
                    }
                    .col-2 {
                        margin-left: 6px;
                        width: 528px;
                        background: url('../../assets/overview/overview_card_train.png');
                        background-size: cover;
                        padding: 38px 43px 0;
                        box-sizing: border-box;
                        .title {
                            color: #D79625;
                            font-size: 32px;
                        }
                        .des {
                            margin-top: 10px;
                            color: #D79625;
                            font-size: 16px;
                            line-height: 26px;
                            font-family: HelveticaNeue, Arial;
                        }
                    }
                }

                .row1 {
                    display: block;
                    margin-top: 6px;
                    background: url('../../assets/overview/overview_card_welms.png');
                    background-size: cover;
                    padding: 38px 0 0 40px;
                    box-sizing: border-box;
                    .title {
                        color: #ffffff;
                        font-size: 32px;
                    }
                    .des {
                        margin-top: 10px;
                        color: #ffffff;
                        font-size: 16px;
                        font-family: HelveticaNeue, Arial;
                    }
                }
            }
            .module-box2 {
                margin-top: 6px;
                span {
                    display: inline-block;
                }
                .row1 {
                    display: flex;
                    align-items: center;
                    height: 100px;
                    background: url('../../assets/overview/overview_card_welms2.png');
                    background-size: cover;
                    box-sizing: border-box;
                    padding-left: 40px;
                    color: #0F41CF;
                    .label {
                        font-size: 32px;
                    }
                    .small {
                        margin-left: 61px;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        position: relative;
                        &::before {
                            position: absolute;
                            content: '';
                            width: 1px;
                            height: 16px;
                            background: #0f41cf;
                            left: -31px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
                .row2 {
                    display: flex;
                    align-items: center;
                    margin-top: 6px;
                    height: 100px;
                    background: url('../../assets/overview/overview_card_Infrastructure.png');
                    background-size: cover;
                    box-sizing: border-box;
                    padding-left: 40px;
                    color: #ffffff;
                    .label {
                        font-size: 32px;
                    }
                    .small {
                        margin-left: 61px;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        position: relative;
                        &::before {
                            position: absolute;
                            content: '';
                            width: 1px;
                            height: 16px;
                            background: #ffffff;
                            left: -31px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
            }
        }
    }

    .project-box3 {
        box-sizing: border-box;
        padding: 80px 0 100px;
        width: 1200px;
        overflow: hidden;
        margin: 0 auto;
        h3 {
            width: 1200px;
            font-size: 48px;
            color: #000000;
            margin: 0 auto;
        }

        p {
            box-sizing: border-box;
            width: 1200px;
            padding-right: 72px;
            font-size: 16px;
            color: #000000;
            margin: 50px auto 90px;
            font-family: HelveticaNeue, Arial;
            line-height: 34px;
        }

        .box-list {
            display: flex;
            width: 1200px;
            margin: 0 auto;
            .left,.right {
                font-size: 0;
                width: 600px;
                img {
                    width: 100%;
                }

                .desc {
                    height: 127px;
                    box-sizing: border-box;
                    .title {
                        position: relative;
                        font-size: 24px;
                    }
                    .info {
                        font-size: 24px;
                        margin: 0;
                        color: #666666;
                        font-family: HelveticaNeue, Arial;
                    }
                }
            }

            .right {
                .desc {
                    padding:33px 0 0 40px;
                }
                .title {
                    &::before {
                        position: absolute;
                        content: '';
                        width: 0;
                        height: 0;
                        left: -17px;
                        top: 50%;
                        transform: translateY(-50%);
                        border-top: 8px transparent solid;
                        border-left: 12px solid #FD8E0D;
                        border-bottom: 8px transparent solid;
                    }
                }
            }

            .left {
                .desc {
                    padding:33px 40px 0 0;
                }
                .title {
                    text-align: right;
                    &::after {
                        position: absolute;
                        content: '';
                        width: 0;
                        height: 0;
                        right: -17px;
                        top: 50%;
                        transform: translateY(-50%);
                        border-top: 8px transparent solid;
                        border-right: 12px solid #FD8E0D;
                        border-bottom: 8px transparent solid;
                    }
                }
                .info {
                    text-align: right;
                }
            }
        }
    }

    .project-box4 {
        height: 700px;
        background-image: url('../../assets/overview/overview_data_bg.jpg');
        background-size: cover;
        background-position: center;
        .main {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            min-height: 610px;
            .box-left {
                width: 520px;
                padding-bottom: 1px;
                overflow: hidden;
                h3 {
                    color: #ffffff;
                    font-size: 48px;
                    padding-top: 70px;
                }
                .p1 {
                    margin-top: 50px;
                    width: 500px;
                    color: #ffffff;
                    font-size: 24px;
                    font-family: HelveticaNeue, Arial;
                    line-height: 40px;
                }

                .p2 {
                    margin-top: 50px;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 34px;
                }
                .more {
                    margin-top: 50px;
                    img {
                        width: 70px;
                        height: 70px;
                        vertical-align: middle;
                    }
                    span {
                        margin-left: 16px;
                        color: #ffffff;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        vertical-align: middle;
                    }
                }
            }

            .box-right {
                margin-left: 78px;
                flex: 1;
                display: flex;
                .left,.right{
                    flex: 1;
                    li {
                        font-size: 0;
                    }
                    img {
                        width: 100%;
                        height: 198px;
                    }
                }

                .left {
                    padding-top: 168px;
                }

                .right {
                    padding-top: 138px;
                }
            }
        }
    }

    .project-box5 {
        display: flex;
        min-width: 1200px;
        min-height: 560px;
        .left {
            flex: 1;
            img {
                width: 100%;
                height: 100%;
            }
        }

        .right {
            flex: 1;
            box-sizing: border-box;
            padding: 4.5% 0 0 7%;
            h3 {
                color: #0e38b1;
                font-size: 60px;
            }

            .p1 {
                margin-top: 4.5%;
                font-size: 22px;
                font-family: HelveticaNeue, Arial;
            }

            .p2 {      
                padding-right: 20%;
                margin-top: 3%;     
                font-size: 16px;
                font-family: HelveticaNeue, Arial;
                color: #000000;
                line-height: 34px; 
            }

            .more {
                margin-top: 5%;
                img {
                    width: 70px;
                    height: 70px;
                    vertical-align: middle;
                }
                span {
                    margin-left: 16px;
                    font-size: 20px;
                    font-family: HelveticaNeue, Arial;
                    vertical-align: middle; 
                }
            }
        }

    }

    .project-box6 {
        background: #F5F7FB;
        height: 720px;
        box-sizing: border-box;
        padding: 80px 0 0 0 ;
        .main {
            width: 1200px;
            overflow: hidden;
            margin: 0 auto;
            display: flex;
            min-height: 690px;
            .left {
                flex: 1;
                padding-bottom: 5px;
                .logo {
                    width: 80px;
                    vertical-align: middle;
                    margin-right: 24px;
                }
                h3 {
                    font-size: 48px;
                    color: #000000;
                }

                p {
                    font-size: 16px;
                    color: #000000;
                    font-family: HelveticaNeue, Arial;
                    line-height: 30px;
                    padding-right: 34px;
                }

                .p1 {
                    margin-top: 30px;
                }

                .p2 {
                    margin-top: 32px;
                }

                .more {
                    margin-top: 50px;
                    img {
                        width: 70px;
                        height: 70px;
                        vertical-align: middle;
                    }
                    span {
                        margin-left: 16px;
                        color: #333333;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        vertical-align: middle;
                    }
                }
            }

            .right {
                margin-left: 40px;
                width: 554px;
                padding-top: 93px;
                img {
                    width: 100%;
                }
            }
        }
    }

    .project-box7 {
        background-image: url('../../assets/overview/overview_samrtclassroom_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 810px;
        .main {
            width: 1200px;
            margin: 0 auto;
            color: #ffffff;
            h3 {
                padding-top: 80px;
                font-size: 48px;
            }
            p {
                margin-top: 20px;          
                font-size: 20px;
                font-family: HelveticaNeue, Arial;  
            }

            ul {
                width: 740px;
                box-sizing: border-box;
                margin-top: 80px;
                background: #0C0D2B;
                padding: 70px 0 70px 87px;
                font-size: 20px;
                li~li {
                    margin-top: 50px;
                }

                li {
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-top: 9px transparent solid;
                        border-bottom: 9px transparent solid;
                        border-left: 16px solid #F59F44;
                        left: -37px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }

            .more {
                margin-top: 80px;
                img {
                    width: 70px;
                    height: 70px;
                    vertical-align: middle;
                }
                span {
                    margin-left: 16px;
                    color: #ffffff;
                    font-size: 20px;
                    font-family: HelveticaNeue, Arial;
                    vertical-align: middle;
                }
            }
        }
    }

    .project-box8 {
        background: #F1F1F1;
        height: 570px;
        .main {
            width: 1200px;
            overflow: hidden;
            margin: 0 auto;
            display: flex;
            .left {
                width: 640px;
                h3 {
                    padding-top: 150px;
                    font-size: 48px;
                }
                p {
                    margin-top: 30px;
                    font-size: 24px;
                    line-height: 36px;
                    font-family: HelveticaNeue, Arial;
                }
                .more {
                    margin-top: 50px;
                    img {
                        width: 70px;
                        height: 70px;
                        vertical-align: middle;
                    }
                    span {
                        margin-left: 16px;
                        color: #333333;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        vertical-align: middle;
                    }
                }
            }
            .right {
                flex: 1;
                margin-left: 28px;
                padding-top: 60px;
                img {
                    width: 100%;
                }
            }
        }
    }

    .project-box9 {
        height: 500px;
        background: #6791FD;
        .main {
            width: 1200px;
            overflow: hidden;
            height: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            .left {
                width: 560px;
                img {
                    width: 100%;
                }
            }
            .right {
                flex: 1;
                margin-left: 100px;
                color: #ffffff;
                .logo {
                    width: 150px;
                    margin-bottom: 30px;
                }
                p {
                    font-size: 16px;
                    line-height: 34px;
                    font-family: HelveticaNeue, Arial;
                }
                .more {
                    margin-top: 40px;
                    img {
                        width: 70px;
                        height: 70px;
                        vertical-align: middle;
                    }
                    span {
                        margin-left: 16px;
                        color: #ffffff;
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial;
                        vertical-align: middle;
                    }
                }
            }
        }
    }

    .project-box10 {
        height: 1036px;
        .main {
            width: 1200px;
            overflow: hidden;
            margin: 0 auto;
            h3 {
                padding-top: 115px;
                font-size: 48px;
                color: #000000;
            }
            .info {
                margin-top: 63px;
                width: 100%;
                position: relative;
                padding-top: 27px;
                .left {
                    box-sizing: border-box;
                    padding: 50px 40px;
                    height: 366px;
                    width: 1020px;
                    background: #F3F5FF;
                    h3 {
                        width: 640px;
                        font-size: 24px;
                        padding: 0;
                        color: #3A7EF2;
                        line-height: 34px;
                        margin-bottom: 30px;
                    }

                    p {
                        padding-left: 30px;                    
                        font-size: 16px;
                        font-family: HelveticaNeue, Arial;
                        color: #3A7EF2;
                        line-height: 16px;
                        span {
                            font-style: oblique;
                            font-size: 24px;
                        }
                    }
                    p~p {
                        margin-top: 16px;
                    }
                }

                .right {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 420px;
                    height: 420px;
                    border-radius: 50%;
                    background: #F59F44;
                    color: #ffffff;
                    text-align: center;
                    h3 {
                        padding-top: 93px;
                        font-size: 30px;
                        color: #ffffff;
                        margin-bottom: 40px;
                    }

                    p {
                        font-family: HelveticaNeue, Arial;
                        font-size: 18px;
                    }
                    p~p {
                        font-size: 18px;
                        margin-top: 10px;
                    }
                }
            }

            h4 {
                font-size: 24px;
                padding:40px 0 0 40px;
            }

            .desc{
                font-size: 14px;
                margin-top: 18px;
                padding-left: 40px;
                width: 788px;
                line-height: 24px;
                color: rgba(0, 0, 0, 0.5);
                font-family: HelveticaNeue, Arial;
                height: 60px;
            }
            .on {
                transition: all 0.25s linear;
                position: absolute;
                transform: translateX(-50%);
                width: 48px;
                height: 20px;
                top: 0px;
                &:before {
                    display: block;
                    z-index: 1;
                    position: relative;
                    content: '';
                    height: 0;
                    width: 0;
                    border-top: 14px solid rgba(51, 51, 51, 1);
                    border-left: 24px solid transparent;
                    border-right: 24px solid transparent;
                }
                &:after {
                    position: absolute;
                    display: block;
                    transform: translateX(-50%);
                    content: '';
                    height: 0;
                    width: 0;
                    left: 24px;
                    z-index: 1;
                    top: 0px;
                    border-top: 13px solid #ffffff;
                    border-left: 22px solid transparent;
                    border-right: 22px solid transparent;
                }

            }

            ul {
                margin-top: 34px;
                display: flex;
                border-top: 1px solid rgba(51, 51, 51, 1);
                padding-top: 9px;
                li {
                    flex: 1;
                    cursor: pointer;
                    position: relative;
                    img {
                        height: 100%;
                        width: 100%;
                    }
                }
                
                // .on {
                //     &:before {
                //         display: block;
                //         top: -10px;
                //         left: 50%;
                //         transform: translateX(-50%);
                //         content: '';
                //         position: absolute;
                //         height: 0;
                //         width: 0;
                //         border-top: 14px solid rgba(51, 51, 51, 1);
                //         border-left: 24px solid transparent;
                //         border-right: 24px solid transparent;
                //     }
                //     &:after {
                //         display: block;
                //         top: -10px;
                //         left: 50%;
                //         transform: translateX(-50%);
                //         content: '';
                //         position: absolute;
                //         height: 0;
                //         width: 0;
                //         border-top: 13px solid #ffffff;
                //         border-left: 22px solid transparent;
                //         border-right: 22px solid transparent;
                //     }

                // }
            }
        }
    }
}
.lang-ru {
    .project-main {
        .icon-see-name {
            font-size: 24px!important;
            font-weight: bold;
        }
        .project-box2 .module3 .module-box1 .right {
            font-size: 30px;
            line-height: 40px!important;
        }
    }
    .project-main .project-box4 .main {
        min-height: 670px;
    }
    
}
.lang-fr {
    .project-main .project-box2 .module1 {
        padding-top: 190px;
    }
    .project-main {
        .icon-see-name {
            font-size: 24px!important;
            font-weight: bold;
        }
        .project-box2 .module3 .module-box1 .right {
            font-size: 30px;
            line-height: 40px!important;
        }
    }
    
}

</style>